import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const activeStyles = /*#__PURE__*/css(["border:", ";padding-block:", ";background-color:", ";:hover{border:", ";background-color:", ";}a,p{font-weight:normal;}", ""], ({
  theme
}) => theme.selectableContainer.border.selected, ({
  theme
}) => theme.controls.paddingBlock.base2pxBorder.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.selectableContainer.border.selectedHover, ({
  theme
}) => theme.selectableContainer.backgroundColor.hover, isMobile(css(["padding-block:", ";"], ({
  theme
}) => theme.controls.paddingBlock.base2pxBorder.mobile)));
const normalStyles = /*#__PURE__*/css(["border:", ";background-color:", ";:hover{border:", ";background-color:", ";}"], ({
  theme
}) => theme.selectableContainer.border.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.selectableContainer.border.hover, ({
  theme
}) => theme.selectableContainer.backgroundColor.hover);
const StyledToggleButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1vzueig-0"
})(["background-color:", ";font:", ";padding-block:", ";padding-inline:", ";border-radius:", ";color:", ";cursor:pointer;text-align:center;vertical-align:middle;user-select:auto;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}", " ", " :focus-visible{outline:none;", "}:disabled{pointer-events:all;cursor:not-allowed;outline:none;opacity:1;color:", ";border-color:", ";background-color:", ";}"], ({
  theme,
  $active
}) => $active ? theme.selectableContainer.backgroundColor.selected : theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, ({
  theme
}) => theme.controls.paddingInline.large.default, ({
  theme
}) => theme.border.radius.medium, ({
  theme
}) => theme.text.color.secondary, isMobile(css(["padding-block:", ";padding-inline:", ";font:", ";"], ({
  theme
}) => theme.controls.paddingBlock.base.mobile, ({
  theme
}) => theme.controls.paddingInline.large.mobile, ({
  theme
}) => theme.font.text.base.mobile)), ({
  $active
}) => $active ? activeStyles : normalStyles, focusOutline, ({
  theme
}) => theme.text.color.unavailable, ({
  theme
}) => theme.color.transparent, ({
  theme,
  $active
}) => $active ? theme.selectableContainer.backgroundColor.selected : theme.selectableContainer.backgroundColor.default);
StyledToggleButton.displayName = 'StyledToggleButton';
const ToggleButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    active = false,
    disabled = false,
    type = 'button',
    taktId,
    taktValue,
    ...rest
  } = props;
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('toggle-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(StyledToggleButton, _extends({}, getDataTaktAttributes(), rest, {
    ref: ref,
    $active: active,
    role: "switch",
    "aria-checked": active,
    disabled: disabled,
    type: type
  })));
});

export { ToggleButton as T };
//# sourceMappingURL=ToggleButton-BlLAyQC8.js.map
